module.exports = __webpack_public_path__ + "static/media/projectPic10.66d1104e.png";